<template>
  <router-link
    :id="`section-${link}`"
    class="course-index"
    data-event="link"
    data-action="click"
    data-name="onclick"
    data-type="internal link"
    data-region="main content"
    :data-section="name.toLowerCase()"
    data-text="view all courses"
    :to="`/${link}`"
    :data-title="name.toLowerCase()"
  >
    <section class="row col-lg-11 mx-auto px-0 bg-white shadow my-5">
      <div
        class="col-lg-5 px-0 bg-image"
        :style="{ backgroundImage: `url('${getImageUrl(image)}')` }"
      ></div>
      <div class="col-lg-7 d-flex align-items-center p-4">
        <section class="details">
          <h3 class="font36 font-weight-bold">{{name}}</h3>
          <p class="font16">{{description}}</p>
          <div class="float-right">
            <router-link v-if="isAuthenticated" tag="span" :to="`/${link}`" class="nav-items" exact>
              <a
                class="nav-link"
                data-event="link"
                data-action="click"
                data-name="onclick"
                data-type="internal link"
                data-region="main content"
                :data-section="name.toLowerCase()"
                :data-title="name.toLowerCase()"
              >View all courses</a>
            </router-link>
          </div>
        </section>
      </div>
    </section>
  </router-link>
</template>

<script>
export default {
  data() {
    return {
      courseStatus: {
        available: {
          display: "Enroll in this course",
          button: "btn btn-secondary"
        }
      }
    };
  },
  props: {
    name: String,
    image: String,
    link: String,
    description: String,
    status: {
      type: String,
      default: ""
    },
    availablity: {
      type: String,
      default: ""
    },
    isAuthenticated: Boolean
  },
  methods: {
    getImageUrl(image) {
      return require(`../assets/images/${image}`);
    }
  }
};
</script>

<style lang="css">
.details {
  padding: 32px 0;
}
.availablity {
  background-color: black;
  color: white;
  padding: 5px;
}
.bg-image {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 40%;
  overflow: hidden;
}
.course-index {
  text-decoration: none;
  color: black;
  overflow: hidden;
}

.course-index:hover {
  text-decoration: none;
  color: black;
}
@media (max-width: 554px) {
  .bg-image {
    height: 200px;
  }
}
</style>
